import React from 'react'
import firebase from 'gatsby-plugin-firebase'
import 'firebase/auth'

import { stringify as stringifyQuery, parse as parseQuery } from 'query-string'

const emulateFirebase = process.env.GATSBY_USE_EMULATED_FIREBASE
if (emulateFirebase) {
  const auth = firebase.auth()
  auth.useEmulator('http://localhost:9099')
}

const buildCampaignUrl = (options) => {
  const { source, medium, campaign, content } = options

  let referrer = document.referrer ? new URL(document.referrer) : undefined
  // disable self-referral
  if (referrer && referrer.host === window.location.host) {
    referrer = undefined
  }

  const urlParams = {
    utm_source: source ? source : referrer,
    utm_medium: medium,
    utm_campaign: campaign,
    utm_content: content,
  }

  const originalQuery = parseQuery(window.location.search)
  const search = '?' + stringifyQuery({ ...originalQuery, ...urlParams })
  const url = window.location.origin + window.location.pathname + search
  return url
}

const sendToSegment = () => {
  const isSignedIn = !!firebase.auth().currentUser

  window.analytics.page({
    isSignedIn,
  })
}

const trackPageChange = () => {
  if (!window.analytics) {
    return
  }

  // code below based on https://github.com/gatsbyjs/gatsby/blob/f0689ffce82e8b59a02df5c338470bd31a5154f2/packages/gatsby-plugin-google-gtag/src/gatsby-browser.js
  // wrap inside a timeout to make sure react-helmet is done with its changes (https://github.com/gatsbyjs/gatsby/issues/11592)
  if (`requestAnimationFrame` in window) {
    requestAnimationFrame(() => {
      requestAnimationFrame(sendToSegment)
    })
  } else {
    // simulate 2 rAF calls
    setTimeout(sendToSegment, 32)
  }
}

// gatsby-browser.js
const onRouteUpdate = ({ prevLocation }) => {
  const { promoCode, referralCode, share } = parseQuery(window.location.search)

  let campaignUrl
  if (promoCode) {
    let promo = promoCode.toUpperCase()
    campaignUrl = buildCampaignUrl({
      campaign: `Partner Promotion ${promo}`,
      content: promo,
      medium: 'affiliate',
    })
  }

  if (referralCode) {
    campaignUrl = buildCampaignUrl({
      campaign: 'Refer-a-friend',
      content: referralCode,
      medium: 'refer-a-friend',
    })
  }

  if (share) {
    campaignUrl = buildCampaignUrl({
      campaign: `Stronger-together`,
      content: share,
      medium: 'shared',
    })
  }
  if (campaignUrl) {
    window.history.replaceState({}, '', campaignUrl)
  }

  // This `if/then` logic relates to the `delayLoad` functionality to help prevent
  // calling `trackPage` twice. If you don't use that feature, you can ignore.
  // Here call `trackPage` only _after_ we change routes (on the client).
  if (prevLocation && window.segmentSnippetLoaded === false) {
    window.segmentSnippetLoader(() => {
      trackPageChange()
    })
  } else {
    trackPageChange()
  }
}

export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    // eslint-disable-next-line no-unused-expressions
    import(`intersection-observer`)
  }
  if (process.env.NODE_ENV !== 'production') {
    const whyDidYouRender = require('@welldone-software/why-did-you-render')
    whyDidYouRender(React, {
      trackAllPureComponents: false,
    })
  }
}

export { onRouteUpdate }
